export default __webpack_public_path__ + "static/media/LDREdited.3c8a1790.jpeg";